import { useAppSelector } from '@store';
import ExpandableRow from './expandable-row';
import ExpandableRowContent from './expandable-row-content';
import { RiskScoringTypes } from '../../../hoc/customers/types';
import { AmlComponentProps } from './types';

const SicCodes = ({
  expandedRows,
  setExpandedRows,
  values,
  // onSend,
  // onDelete,
  isEditable,
}: AmlComponentProps) => {
  const { sicCodesDictionaries } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  return (
    <ExpandableRow
      name={RiskScoringTypes.SIC_CODES}
      title="Sic Codes"
      expandedRows={expandedRows}
      setExpandedRows={setExpandedRows}
      totalRisk={values?.sicRiskTotal as number}
      // comments={[]}
      // onSend={onSend}
      // onDelete={onDelete}
    >
      {values?.sicRiskItems?.map((item) => (
        <ExpandableRowContent
          key={item.name}
          value={`${
            sicCodesDictionaries?.find((sicCode) => sicCode.name === item.name)
              ?.name as string
          } - ${
            sicCodesDictionaries?.find((sicCode) => sicCode.name === item.name)
              ?.description as string
          }
          `}
          // TODO: Check risk={item.riskScore as number}
          risk={
            item.value?.toString() !== 'null' &&
            item.value?.toString() !== 'undefined'
              ? item.value?.toString()
              : '-'
          }
          name={
            sicCodesDictionaries?.find((sicCode) => sicCode.name === item.name)
              ?.name
          }
          isEditable={isEditable}
        />
      ))}
    </ExpandableRow>
  );
};

export default SicCodes;
